import { Outlet, useParams } from "react-router-dom";

import { useRound } from "@/routes/round/queries";

export default function RoundLayout() {
    const { roundId } = useParams<{ roundId: string }>();

    const { round, loading, error, refetch } = useRound(roundId);

    if (!roundId) {
        return null;
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!round) {
        return <p>Round not found</p>;
    }

    return <Outlet context={{ round, refetch }} />;
}
